// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HeZu","type":"styles_type__3PE1J","choices":"styles_choices__1GzJY"};